import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, browserPopupRedirectResolver } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyCcGnlPt2oc3u_py0QKAL5e5T1gfH7zFlM',
  authDomain: 'youstory.studio.aimpulse.io',
  projectId: 'youstory-ai',
  storageBucket: 'youstory-ai.appspot.com',
  messagingSenderId: '896106335063',
  appId: '1:896106335063:web:59f3e25afa56b0d67ecc12',
};

const app = initializeApp(firebaseConfig);

const database = getFirestore(app);
export { database };

const auth = getAuth(app);
export { auth, browserPopupRedirectResolver };

const storage = getStorage(app);
export { storage };
